/* Hover-open header dropdowns - mouse devices only (The Stitched Cow) */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var CLOSE_DELAY = 250;
  var all = [];
  function close(details) {
    if (details.open) {
      details.open = false;
      var s = details.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', 'false');
    }
  }
  document.querySelectorAll('header-menu > details, details.mega-menu').forEach(function (details) {
    var li = details.closest('li') || details;
    var timer = null;
    all.push({ details: details, cancel: function () { clearTimeout(timer); } });
    li.addEventListener('mouseenter', function () {
      clearTimeout(timer);
      /* close any sibling dropdown instantly so menus never overlap */
      all.forEach(function (o) {
        if (o.details !== details) { o.cancel(); close(o.details); }
      });
      if (!details.open) {
        details.open = true;
        var s = details.querySelector('summary');
        if (s) s.setAttribute('aria-expanded', 'true');
      }
    });
    li.addEventListener('mouseleave', function () {
      timer = setTimeout(function () { close(details); }, CLOSE_DELAY);
    });
    /* keep click working as a toggle for mixed-input devices */
  });
})();
